var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9782 6.8778H7.62261V2.52225C7.62261 2.35722 7.55706 2.19896 7.44037 2.08227C7.32368 1.96558 7.16541 1.90002 7.00039 1.90002C6.83537 1.90002 6.6771 1.96558 6.56041 2.08227C6.44372 2.19896 6.37817 2.35722 6.37817 2.52225V6.8778H2.02261C1.85759 6.8778 1.69932 6.94336 1.58264 7.06005C1.46595 7.17674 1.40039 7.335 1.40039 7.50002C1.40039 7.66505 1.46595 7.82331 1.58264 7.94C1.69932 8.05669 1.85759 8.12225 2.02261 8.12225H6.37817V12.4778C6.37817 12.6428 6.44372 12.8011 6.56041 12.9178C6.6771 13.0345 6.83537 13.1 7.00039 13.1C7.16541 13.1 7.32368 13.0345 7.44037 12.9178C7.55706 12.8011 7.62261 12.6428 7.62261 12.4778V8.12225H11.9782C12.1432 8.12225 12.3015 8.05669 12.4181 7.94C12.5348 7.82331 12.6004 7.66505 12.6004 7.50002C12.6004 7.335 12.5348 7.17674 12.4181 7.06005C12.3015 6.94336 12.1432 6.8778 11.9782 6.8778Z",
    fill: "#1F2A37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusAddIcon);
export default __webpack_public_path__ + "static/media/PlusAddIcon.6a0989c78b85fa58b3577377116ef7e3.svg";
export { ForwardRef as ReactComponent };